// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function FileChartLine(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "FileChartLine" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3V21H19V7L14 3H5ZM7 16.8132V19H17V11L13.244 16.3922L11.4019 14.4499L8.57898 17.4788L7 16.8132Z", fill: "currentColor" }))));
});
//# sourceMappingURL=FileChartLine.js.map